export default "__VITE_ASSET__88a7d934__"